"use client";

import { ThumbnailGenerator } from "@sticker-giant/sg-frontend-common";
import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

interface Props {
  bucket: string;
  filepath: string;
  title: string;
  page?: number;
  children: ReactNode;
}

export function ImagePreviewDialog({ bucket, filepath, title, page, children }: Props) {
  const previewUrl = ThumbnailGenerator.getUrl2({ bucket, filepath, page, maxWidth: 2000, maxHeight: 2000, dpi: 300 });

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-h-[90dvh] sm:max-w-[90vw]" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="text-center text-sm">{title}</DialogTitle>
        </DialogHeader>
        {/* biome-ignore lint/performance/noImgElement: external unoptimized thumbnail, next/image adds no value */}
        <img src={previewUrl} alt={title} className="max-h-[calc(90dvh-6rem)] w-full object-contain" />
      </DialogContent>
    </Dialog>
  );
}
